import register from '@kpsys/angularjs-register';

import './sdi-requests.less';
import dataServiceModule from '../../commons/data-services/data-services.module';
import sdiRequestsRoutes from './sdi-requests.routes';

/**
 * @ngdoc module
 * @name uc.sdi-requests
 * @module uc.sdi-requests
 *
 * @description
 */

export default register('uc.sdi-requests', [dataServiceModule])
    .config(sdiRequestsRoutes)
    .name();
